import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CRUDService } from '#services/api/crud.service';
import { environment } from '#environments/environment';
import { EquipmentType } from 'models';

@Injectable()
export class EquipmentTypeService extends CRUDService<EquipmentType> {
    constructor(http: HttpClient) {
        super(http, `${environment.apiEndpoint}/equipment-types`);
    }
}
